/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { BaseError } from '../../../shared/errors/Errors';
import { ClientNewsSource, ClientNewsSourceCreateRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
export const GET_NEWS_SOURCES_REQUEST = 'GET_NEWS_SOURCES_REQUEST';
export const GET_NEWS_SOURCES_SUCCESS = 'GET_NEWS_SOURCES_SUCCESS';
export const GET_NEWS_SOURCES_FAILURE = 'GET_NEWS_SOURCES_FAILURE';
export const CREATE_NEWS_SOURCES_REQUEST = 'CREATE_NEWS_SOURCES_REQUEST';
export const CREATE_NEWS_SOURCES_SUCCESS = 'CREATE_NEWS_SOURCES_SUCCESS';
export const CREATE_NEWS_SOURCES_FAILURE = 'CREATE_NEWS_SOURCES_FAILURE';

export interface GetNewsSourcesRequestAction {
	type: typeof GET_NEWS_SOURCES_REQUEST;
}

export interface GetNewsSourcesSuccessAction {
	type: typeof GET_NEWS_SOURCES_SUCCESS;
	clientNewsSource: ClientNewsSource[];
}

export interface GetNewsSourcesFailureAction {
	type: typeof GET_NEWS_SOURCES_FAILURE;
	error: BaseError | null;
}

export interface CreateNewsSourcesRequestAction {
	type: typeof CREATE_NEWS_SOURCES_REQUEST;
	newsSourcesRequestData: ClientNewsSourceCreateRequest;
}

export interface CreateNewsSourcesSuccessAction {
	type: typeof CREATE_NEWS_SOURCES_SUCCESS;
	newsSourcesSuccessData: ClientNewsSource;
}

export interface CreateNewsSourcesFailureAction {
	type: typeof CREATE_NEWS_SOURCES_FAILURE;
	error: BaseError | null;
}

export type NewsSourcesActionTypes =
	| CreateNewsSourcesRequestAction
	| CreateNewsSourcesFailureAction
	| CreateNewsSourcesSuccessAction
	| GetNewsSourcesRequestAction
	| GetNewsSourcesSuccessAction
	| GetNewsSourcesFailureAction;
